module.exports = "/static/assets/75224f0798b20e31db0421d08a62d794.png";